/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentCardDto
 */
export interface NovitusPaymentCardDto {
    /**
     * Nazwa formy płatności
     * @type {string}
     * @memberof NovitusPaymentCardDto
     */
    name?: string;
    /**
     * Wartość płatności
     * @type {string}
     * @memberof NovitusPaymentCardDto
     */
    value: string;
    /**
     * Czy płatność powinna być wysłana do terminala EFT
     * @type {object}
     * @memberof NovitusPaymentCardDto
     */
    to_eft: object;
}

/**
 * Check if a given object implements the NovitusPaymentCardDto interface.
 */
export function instanceOfNovitusPaymentCardDto(value: object): value is NovitusPaymentCardDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('to_eft' in value) || value['to_eft'] === undefined) return false;
    return true;
}

export function NovitusPaymentCardDtoFromJSON(json: any): NovitusPaymentCardDto {
    return NovitusPaymentCardDtoFromJSONTyped(json, false);
}

export function NovitusPaymentCardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentCardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'],
        'to_eft': json['to_eft'],
    };
}

export function NovitusPaymentCardDtoToJSON(value?: NovitusPaymentCardDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
        'to_eft': value['to_eft'],
    };
}

